<!-- 
    가장 최근의 SnapshotData를 기준으로 Type별 Status의 현황을 보여주는 그래프

 -->

 <template>
    <b-row class="w-100 d-flex justify-content-center align-items-center flex-nowrap h-80" style="margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>

        
        <div class="h-100" style="flex:3; position: relative; padding:0;">
            <apexchart v-if="showGraph" id="chart"
            width="100%" height="100%" ref="apexchart" 
            :options="chartOptions"
                :series="series" />
        </div>
    </b-row>
    <!-- <b-row class="w-100 d-flex justify-content-center align-items-center flex-nowrap" :class="isFlexible ? 'h-100' : 'h-80'" style="margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="series" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        
        <div class="change-today-graph h-100" style="flex:3; position: relative;" :style="isFlexible ? 'padding: 20px 0;' : 'padding: 0;'">
            <apexchart v-if="series" id="chart"
            width="100%" height="100%" ref="apexchart" 
            :options="chartOptions"
                :series="series" />
        </div>
        <div v-if="isFlexible && tableData" class="d-flex align-items-center justify-content-center flex-column h-100" style="flex:1">
            <ChartTable :tableData="tableData"/>
        </div>
    </b-row> -->
</template>

<script scoped>
import VueApexCharts from "vue-apexcharts";
export default {
    name: 'DocumentsByDayOfWeekAndHoliday',

    components: {
        apexchart: VueApexCharts,
    },
    created() {
        // this.series.forEach(item => {
        //     this.graphSeries.push(item.data);
        //     this.graphLabels.push(item.name);
        // });
        // 차트를 업데이트
        // if (this.$refs.apexchart) {
        //         this.$refs.apexchart.updateOptions({
        //             xaxis: {
        //                 categories: this.categories,
        //             },
        //         });
        //     }

        // this.chartOptions.labels = this.categories;
        this.chartOptions.xaxis.categories = ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
        // this.chartOptions.xaxis.categories = ['Category 1', 'Category 2', 'Category 3'],

        this.showGraph = true;
    },
    data() {
        return {
            loading : false,
            showGraph: false,
            series: [
                    {
                        name: '소멸 예정 쿠폰',
                        data: [
                    {
                        x: '1월',
                        y: 452217,
                        fillColor: '#1BD4D4' // 첫 번째 데이터 포인트 색상
                    },
                    {
                        x: '2월',
                        y: 402212,
                        fillColor: '#1BD4D4' // 두 번째 데이터 포인트 색상
                    },
                    {
                        x: '3월',
                        y: 372112,
                        fillColor: '#1BD4D4' // 세 번째 데이터 포인트 색상
                    },
                    {
                        x: '4월',
                        y: 351212,
                        fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    },
                    // {
                    //     x: '5월',
                    //     y: 3996122,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                    // {
                    //     x: '6월',
                    //     y: 3862213,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                    // {
                    //     x: '7월',
                    //     y: 3592231,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                    // {
                    //     x: '8월',
                    //     y: 2512221,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                    // {
                    //     x: '9월',
                    //     y: 1859212,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                    // {
                    //     x: '10월',
                    //     y: 1261212,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                    // {
                    //     x: '11월',
                    //     y: 861231,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                    // {
                    //     x: '12월',
                    //     y: 122121,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                ]}
                // 이하 생략
            ],
                    // data: [12217, 13801, 11699, 11600, 10958, 9102, 12109, 11930, 11079, 12609, 11846, 12597]
                
            
            chartOptions: {
                chart: {
                    height:'90%',
                    type: "bar",
                    stacked: false,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false,
                        // show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: undefined,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: undefined,
                            },
                            png: {
                                filename: undefined,
                            }
                        }
                    },
                },
                // plotOptions: {
                //     bar: {
                //         horizontal: false,
                //         columnWidth: '55%',
                //         endingShape: 'rounded'
                //     },
                // },
                // colors: [function({value, seriesIndex, w}) {
                //     console.log(value);
                //     console.log(seriesIndex);
                //     console.log(w);
                // }],
                // colors: ['#FF5733', '#FFC300', '#FF5733', '#FF5733', '#C70039', '#C70039', '#C70039', '#900C3F', '#900C3F', '#581845', '#581845', '#900C3F'],
                
                dataLabels: {
                    enabled: false, // 데이터 라벨을 사용할 것인지 여부를 설정합니다.
                    style: {
                        fontSize: '10px', // 데이터 라벨의 글꼴 크기를 지정합니다.
                        colors: ['#fff'], // 데이터 라벨의 색상을 지정합니다.
                        fontWeight: 700,
                    },
                    // offsetX: 10, // 데이터 라벨을 가로 방향으로 이동시킵니다.
                    offsetY: -10, // 데이터 라벨을 세로 방향으로 이동시킵니다.
                    formatter: function (val) { // 데이터 라벨의 형식을 설정합니다.
                        return val;
                    },
                    background: { // 데이터 라벨의 배경을 설정합니다.
                        enabled: true,
                        foreColor: '#2E2E38',
                        padding: 5,
                        borderRadius: 7,
                        borderWidth: 1,
                        borderColor: '#ccc',
                        opacity: 1,
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' 개'
                        }
                    },
                    // 툴팁의 스타일 설정
                    enabled: true, // 툴팁 활성화 여부
                    shared: false, // 공유 툴팁 사용 여부 (true 또는 false)
                    // theme: 'dark', // 'dark' 또는 'light' (툴팁의 테마 설정)
                    // custom: function({ series, seriesIndex, dataPointIndex, w }) {
                    // return `<div class="custom-tooltip">${seriesIndex}</div>`;
                    // },
                    style: {
                        background: '#333',
                        color: '#fff',
                        fontSize: '14px',
                        padding: '8px',
                        borderRadius: '10px',
                        border: '1px solid #666',
                    },
                },
                xaxis: {
                    // categories: [],
                    show:true,
                    // axisTicks:this.isFlexible,
                    // labels: {
                    //     show:this.isFlexible
                    // },
                    tooltip: {
                        enabled: false
                    }
                    
                },
                yaxis: {
                    axisTicks:false,
                    labels: {
                       formatter: function (val) {
                            const regex = /\B(?=(\d{3})+(?!\d))/g;

                            if (val >= 1000000000) {
                                return (val / 1000000000).toFixed(1).toString().replace(regex, ",") + 'B'; // 10억 이상의 경우 'billion'으로 표시
                            } else if (val >= 1000000) {
                                return (val / 1000000).toFixed(1).toString().replace(regex, ",") + 'M'; // 백만 이상의 경우 'million'으로 표시
                            } else if (val >= 1000) {
                                return (val / 1000).toFixed(1).toString().replace(regex, ",") + 'K'; // 천 이상의 경우 'thousand'으로 표시
                            }
                            return val; // 그 외의 경우 일반적으로 표시
                        }
                    }
                    // axisTicks:this.isFlexible,
                    // labels: {
                    //     show:this.isFlexible
                    // }
                },
                legend: {
                    show: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: 3,
                    fontSize: '18px'
                    // offsetY: this.isFlexible ? 7 : 3,
                    // fontSize: this.isFlexible ? '14px' : '12px'
                },
                grid : {
                    show:false
                }
            }, 
        }
    },
    methods: {
        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '개'
        }
    },
}
</script>
<style scoped>
/* .count-label {
    font-size: 2.25rem !important;
    font-weight: 500;
}
.count-data {
    margin-top: 20px;
    font-size: 2.5rem;
    font-weight: 600;
} */

.h-80 {
    padding-top: 10px;
    height: 80%;
}
.h-90 {
    height: 90%;
}
</style>
<style>
/* 커스텀 툴팁 스타일 */
.apexcharts-tooltip {
    border-radius: 20px;
}

.change-today-graph .apexcharts-tooltip-series-group.apexcharts-active {
    padding: 0 12px;
}
</style>